export const SALES_ECONOMICS_READINESS_COPY = {
  title: "More comparable data is needed",
  observed: "Registered activity in complete deals",
  observedDescription: "Only deals with complete activity data are included below.",
  registeredWon: "Per complete won deal",
  registeredLost: "Per complete lost deal",
  noRecordedTime: "No registered sales time in the complete deals.",
  noCompleteData: "No deals have complete activity data in this period.",
  current: "Selected period",
  comparison: "Previous period",
  incomplete: "Some deals have incomplete activity data or missing Deal dates.",
  smallSample: "Too few complete won and lost deals for a comparison.",
  sparseMeetings: "Most won or lost deals have no registered meetings.",
  mixedPipelines: "Choose one Pipeline to compare similar deals.",
  missingPipeline: "Pipeline information is missing for some deals.",
  unspecifiedPipeline: "Pipeline not specified",
  refresh: "Refresh data",
  requirements: "Comparisons need 30 complete deals, including five won and five lost, and at least 80% activity coverage for each outcome in both periods. If most deals of either outcome have no registered meetings, only recorded activity is shown. Compare one Pipeline at a time.",
  empty: "No closed deals in this period.",
  longerPeriod: "Try a longer period",
  sixMonths: "Last 180 days",
  twelveMonths: "Last 365 days",
  inspectDeals: "View deals and missing data",
  pipelineTitle: "Compare within a Pipeline",
  pipelineDescription: "Won and lost counts refer to deals with complete activity data.",
  notReady: "More data needed",
  ready: "Ready to compare",
  comparisonUnavailable: "The activity data does not support this comparison yet.",
  stageUnavailable: "More complete stage history is needed for a comparison.",
  riskUnavailable: "More comparable risk and activity data is needed.",
  groupUnavailable: "No group meets the comparison requirements yet.",
} as const;
